const FlowEndService = {
  setPepperOneEnded: (status: string) => {
    sessionStorage.setItem("PepperOne-Status", status);
  },
  getPepperOneEnded: () => {
    return sessionStorage.getItem("PepperOne-Status");
  },
  clearPepperOneEnded: () => {
    sessionStorage.removeItem("PepperOne-Status");
  },
};

export default FlowEndService;
